import { AutomationGroupsRepository } from './automationApi/automation-groups/automation-groups.repository'
import { AutomationGroupsService } from './automationApi/automation-groups/automation-groups.service'
import { AutomationsRepository } from './automationApi/automations/automation.repository'
import { AutomationsService } from './automationApi/automations/automation.service'
import { FacebookRepository } from './automationApi/facebook/facebook.repository'
import { FacebookService } from './automationApi/facebook/facebook.service'
import { CreativesRepository } from './brokerApi/creatives/creatives.repository'
import { CreativesService } from './brokerApi/creatives/creatives.service'
import { RecipientsRepository } from './brokerApi/recipients/recipients.repository'
import { RecipientsService } from './brokerApi/recipients/recipients.service'
import { AudienceRulesRepository } from './eventsApi/audienceRules/audience-rules.repository'
import { AudienceRulesService } from './eventsApi/audienceRules/audience-rules.service'
import { AudiencesRepository } from './eventsApi/audiences/audiences.repository'
import { AudiencesService } from './eventsApi/audiences/audiences.service'
import { ChannelsRepository } from './brokerApi/channels/channels.repository'
import { ChannelsService } from './brokerApi/channels/channels.service'
import { EventSourcesRepository } from './eventsApi/event-sources/event-sources.repository'
import { EventSourcesService } from './eventsApi/event-sources/event-sources.service'
import { EventsRepository } from './eventsApi/events/events.repository'
import { EventsService } from './eventsApi/events/events.service'
import { IntegrationsRepository } from './eventsApi/integrations/integrations.repository'
import { IntegrationsService } from './eventsApi/integrations/integrations.service'
import { IntegrationService as SchedulerIntegrationsService } from './schedulerApi/integrations/integration.service'
import { IntegrationRepository as SchedulerIntegrationsRepository } from './schedulerApi/integrations/integration.repository'
import { AppointmentConsumptionService } from './schedulerApi/appointment-consumption/appointment-consumption.service'
import { UserServiceComissionsService } from './posApi/user-service-comissions/user-service-comissions.service'
import { UserServiceComissionsRepository } from './posApi/user-service-comissions/user-service-comissions.repository'
import { AppointmentConsumptionRepository } from './schedulerApi/appointment-consumption/appointment-consumption.repository'
import { NotesRepository } from './eventsApi/notes/notes.repository'
import { NotesService } from './eventsApi/notes/notes.service'
import { PersonsRepository } from './eventsApi/persons/persons.repository'
import { PersonsService } from './eventsApi/persons/persons.service'
import { ReferralsRepository } from './eventsApi/referrals/referrals.repository'
import { ReferralsService } from './eventsApi/referrals/referrals.service'
import { SettingsRepository } from './eventsApi/settings/settings.repository'
import { SettingsService } from './eventsApi/settings/settings.service'
import { TagsRepository } from './eventsApi/tags/tags.repository'
import { TagsService } from './eventsApi/tags/tags.service'
import { BoardsRepository } from './pipelineApi/pipeline/boards/boards.repository'
import { BoardsService } from './pipelineApi/pipeline/boards/boards.service'
import { CardsRepository } from './pipelineApi/pipeline/cards/cards.repository'
import { CardsService } from './pipelineApi/pipeline/cards/cards.service'
import { ListsRepository } from './pipelineApi/pipeline/lists/lists.repository'
import { ListsService } from './pipelineApi/pipeline/lists/lists.service'
import { BalancesRepository } from './posApi/balances/balances.repository'
import { BalancesService } from './posApi/balances/balances.service'
import { BusinessRepository } from './prospectApi/business/business.repository'
import { BusinessService } from './prospectApi/business/business.service'
import { CitiesService } from './prospectApi/cities/cities.service'
import { CategoriesService as ProspectCategoriesService } from './prospectApi/categories/categories.service'
import { CategoriesRepository as ProspectCategoriesRepository } from './prospectApi/categories/categories.repository'
import { CitiesService as EventsCitiesService } from './eventsApi/cities/cities.service'
import { CitiesRepository as EventsCitiesRepository } from './eventsApi/cities/cities.repository'

import { SearchQueryService } from './prospectApi/search-query/search-query.service'
import { SearchesService } from './prospectApi/searches/searches.service'
import { AppointmentsService } from './schedulerApi/appointments/appointments.service'
import { SchedulerReportsService } from './schedulerApi/reports/reports.service'
import { SchedulerReportsRepository } from './schedulerApi/reports/reports.repository'
import { SchedulesService } from './schedulerApi/schedules/schedules.service'
import { ScheduleGroupsService } from './schedulerApi/schedule-groups/schedule-groups.service'
import { ScheduleBlockRulesService } from './schedulerApi/schedule-block-rules/schedule-block-rules.service'
import { WaitlistEntriesService } from './schedulerApi/waitlist-entries/waitlist-entries.service'
import { DocumentsService } from './toolsApi/documents/documents.service'
import { FormDatasService } from './toolsApi/forms/form-datas/form-datas.service'
import { FormDataLinksService } from './toolsApi/forms/form-data-links/form-data-links.service'
import { FormTemplatesService } from './toolsApi/forms/form-templates/form-templates.service'
import { NPSService } from './toolsApi/nps/nps/nps.service'
import { ReviewsService } from './toolsApi/nps/reviews/reviews.service'
import { ReferralsService as ToolsReferralsService } from './toolsApi/referrals/referrals.service'
import { ReferralsRepository as ToolsReferralsRepository } from './toolsApi/referrals/referrals.repository'
import { CompaniesService } from './usersApi/companies/companies.service'
import { UsersService } from './usersApi/users/users.service'
import { UtilsBrowserService } from './utils/utils-browser.service'
import { CitiesRepository } from './prospectApi/cities/cities.repository'
import { SearchQueryRepository } from './prospectApi/search-query/search-query.repository'
import { SearchesRepository } from './prospectApi/searches/searches.repository'
import { AppointmentsRepository } from './schedulerApi/appointments/appointments.repository'
import { SchedulesRepository } from './schedulerApi/schedules/schedules.repository'
import { ScheduleGroupsRepository } from './schedulerApi/schedule-groups/schedule-groups.repository'
import { ScheduleBlockRulesRepository } from './schedulerApi/schedule-block-rules/schedule-block-rules.repository'
import { WaitlistEntriesRepository } from './schedulerApi/waitlist-entries/waitlist-entries.repository'
import { AgendaNotesService } from './schedulerApi/agenda-notes/agenda-notes.service'
import { AgendaNotesRepository } from './schedulerApi/agenda-notes/agenda-notes.repository'
import { DocumentsRepository } from './toolsApi/documents/documents.repository'
import { FormDatasRepository } from './toolsApi/forms/form-datas/form-datas.repository'
import { FormDataLinksRepository } from './toolsApi/forms/form-data-links/form-data-links.repository'
import { FormTemplatesRepository } from './toolsApi/forms/form-templates/form-templates.repository'
import { NPSRepository } from './toolsApi/nps/nps/nps.repository'
import { ReviewsRepository } from './toolsApi/nps/reviews/reviews.repository'
import { CompaniesRepository } from './usersApi/companies/companies.repository'
import { UsersRepository } from './usersApi/users/users.repository'
import { StatisticsService } from './usersApi/statistics/statistics.service'
import { StatisticsRepository } from './usersApi/statistics/statistics.repository'
import { InvoicesService } from './posApi/invoices/invoices.service'
import { InvoicesRepository } from './posApi/invoices/invoices.repository'
import { PaymentMethodsService } from './posApi/payment-methods/payment-methods.service'
import { PaymentMethodsRepository } from './posApi/payment-methods/payment-methods.repository'
import { ServicesService } from './posApi/services/services.service'
import { ServicesRepository } from './posApi/services/services.repository'
import { ProductInvoicesService } from './posApi/stock/product-invoices/product-invoices.service'
import { ProductInvoicesRepository } from './posApi/stock/product-invoices/product-invoices.repository'
import { ProductMovementsService } from './posApi/stock/product-movements/product-movements.service'
import { ProductMovementsRepository } from './posApi/stock/product-movements/product-movements.repository'
import { ProductConsumptionService } from './posApi/stock/product-consumption/product-consumption.service'
import { ProductConsumptionRepository } from './posApi/stock/product-consumption/product-consumption.repository'
import { PosReportsService } from './posApi/reports/reports.service'
import { PosReportsRepository } from './posApi/reports/reports.repository'
import { ChargesService } from './paymentsApi/charges/charges.service'
import { ChargesRepository } from './paymentsApi/charges/charges.repository'
import { CustomerCardsService } from './paymentsApi/customer-cards/customer-cards.service'
import { CustomerCardsRepository } from './paymentsApi/customer-cards/customer-cards.repository'
import { GatewaysService } from './paymentsApi/gateways/gateways.service'
import { LogsRepository } from './paymentsApi/logs/logs.repository'
import { LogsService } from './paymentsApi/logs/logs.service'
import { GatewaysRepository } from './paymentsApi/gateways/gateways.repository'
import { PaymentLinksService } from './paymentsApi/payment-links/payment-links.service'
import { PaymentLinksRepository } from './paymentsApi/payment-links/payment-links.repository'
import { PurchasesService } from './paymentsApi/purchases/purchases.service'
import { PurchasesRepository } from './paymentsApi/purchases/purchases.respository'
import { SitesProfilesService } from './toolsApi/sites/profiles/profiles.service'
import { SitesProfilesRepository } from './toolsApi/sites/profiles/profiles.repository'
import { SitesLinksService } from './toolsApi/sites/links/links.service'
import { SitesLinksRepository } from './toolsApi/sites/links/links.repository'
import { ComissionsService } from './eventsApi/comissions/comissions.service'
import { ComissionsRepository } from './eventsApi/comissions/comissions.repository'
import { BalanceResultsService } from './posApi/balance-results/balance-results.service'
import { BalanceResultsRepository } from './posApi/balance-results/balance-results.repository'
import { ResourcesLockService } from './schedulerApi/resources-lock/resources-lock.service'
import { ResourcesLockRepository } from './schedulerApi/resources-lock/resources-lock.repository'
import { MemCacheService } from './infra/mem-cache.service'
import { GoalboardsService } from './toolsApi/goalboards/goalboards.service'
import { GoalboardsRepository } from './toolsApi/goalboards/goalboards.repsoitory'
import { BillsService } from './financialApi/bills/bills.service'
import { BillsRepository } from './financialApi/bills/bills.repository'
import { RecurringBillsService } from './financialApi/recurring-bills/recurring-bills.service'
import { RecurringBillsRepository } from './financialApi/recurring-bills/recurring-bills.repository'
import { AccountsService } from './financialApi/accounts/accounts.service'
import { AccountsRepository } from './financialApi/accounts/accounts.repository'
import { CategoriesRepository } from './financialApi/categories/categories.repository'
import { CategoriesService } from './financialApi/categories/categories.service'
import { EntriesService } from './financialApi/entries/entries.service'
import { EntriesRepository } from './financialApi/entries/entries.repository'
import { ClassificationsService } from './financialApi/classifications/classifications.service'
import { ClassificationsRepository } from './financialApi/classifications/classifications.repository'
import { PartnersService } from './toolsApi/partners/partners/partners.service'
import { PartnersRepository } from './toolsApi/partners/partners/partners.repository'
import { PartnersPersonsService } from './toolsApi/partners/persons/partners-persons.service'
import { PartnersPersonsRepository } from './toolsApi/partners/persons/partners-persons.repository'
import { PartnersEntriesService } from './toolsApi/partners/entries/partners-entries.service'
import { PartnersEntriesRepository } from './toolsApi/partners/entries/partners-entries.repository'
import { CashiersService } from './posApi/cashiers/cashiers.service'
import { CashiersRepository } from './posApi/cashiers/cashiers.repository'
import { FilesService } from './eventsApi/files/files.service'
import { ServiceCategoriesService } from './posApi/service-categories/service-categories.service'
import { ServiceCategoriesRepository } from './posApi/service-categories/service-categories.repository'
import { QuotationsService } from './posApi/quotation/quotations.service'
import { QuotationsRepository } from './posApi/quotation/quotations.repository'
import { SharePagesService } from './toolsApi/share-pages/share-pages.service'
import { SharePagesRepository } from './toolsApi/share-pages/share-pages.repository'
import { TaxParamsService } from './posApi/tax-params/tax-params.service'
import { TaxParamsRepository } from './posApi/tax-params/tax-params.repository'
import { BrasilApiService } from './adapters/brasil-api.service'
import { TaxInvoicesService } from './posApi/tax-invoices/tax-invoices.service'
import { TaxInvoicesRepository } from './posApi/tax-invoices/tax-invoices.repository'
import { ReportsService } from './financialApi/reports/reports.service'
import { ReportsRepository } from './financialApi/reports/reports.repository'
import { MGMembersService } from './toolsApi/mgmembers/mgmembers.service'
import { MGMembersRepository } from './toolsApi/mgmembers/mgmembers.repository'
import { FormV2TemplatesService } from './toolsApi/forms-v2/form-v2-templates/form-v2-templates.service'
import { FormV2TemplatesRepository } from './toolsApi/forms-v2/form-v2-templates/form-v2-templates.repository'
import { FormV2FormsService } from './toolsApi/forms-v2/form-v2-forms/form-v2-forms.service'
import { FormV2FormsRepository } from './toolsApi/forms-v2/form-v2-forms/form-v2-forms.repository'
import { FormV2FormLinksService } from './toolsApi/forms-v2/form-v2-form-links/form-v2-form-links.service'
import { FormV2FormLinksRepository } from './toolsApi/forms-v2/form-v2-form-links/form-v2-form-links.repository'
import { FormV2FormSignaturesService } from './toolsApi/forms-v2/form-v2-form-signatures/form-v2-form-signatures.service'
import { FormV2FormSignaturesRepository } from './toolsApi/forms-v2/form-v2-form-signatures/form-v2-form-signatures.repository'
import { FormV2FormSignatureLogsService } from './toolsApi/forms-v2/form-v2-signature-logs/form-v2-form-signature-logs.service'
import { FormV2FormSignatureLogsRepository } from './toolsApi/forms-v2/form-v2-signature-logs/form-v2-form-signature-logs.repository'
import { ManagersService } from './usersApi/managers/managers.service'
import { ManagersRepository } from './usersApi/managers/managers.repository'
import { MedialistsRepository } from './toolsApi/academy/medialists/medialists.repository'
import { MedialistsService } from './toolsApi/academy/medialists/medialists.service'
import { MediasService } from './toolsApi/academy/medias/medias.servide'
import { MediasRepository } from './toolsApi/academy/medias/medias.repository'
import { BrokerBalancesService } from './brokerApi/balances/balances.service'
import { BrokerBalancesRepository } from './brokerApi/balances/balances.repository'
import { InternetCheckService } from './utils/internet-check.service'
import { DatesService } from './utils/dates.service'
import { ImagesService } from './utils/images.service'
import { CountriesService } from './eventsApi/countries/countries.service'
import { CountriesRepository } from './eventsApi/countries/countries.repository'
import { GeoService } from './eventsApi/geo/geo.service'
import { CepGeoRepository, GeoRepository } from './eventsApi/geo/geo.repository'
import { ConversionsService } from './utils/conversions.service'
import { DevicesService } from './usersApi/devices/devices.service'
import { DevicesRepository } from './usersApi/devices/devices.repository'
import { AuthService } from './usersApi/auth/auth.service'
import { AuthRepository } from './usersApi/auth/auth.repository'
import { OAuthService } from './usersApi/oauth/oauth.service'
import { OAuthRepository } from './usersApi/oauth/oauth.repository'
import { ReportCatalogService } from './reportsApi/catalog/report-catalog.service'
import { ReportCatalogRepository } from './reportsApi/catalog/report-catalog.repository'
import { NotificationsService } from './notificationsApi/notifications.service'
import { NotificationsRepository } from './notificationsApi/notifications.repository'

export class APIService {
    cache = new MemCacheService()
    adapters = {
        BrasilAPI: new BrasilApiService(),
    }
    automations = {
        automationGroups: new AutomationGroupsService(new AutomationGroupsRepository()),
        // as ações vivem sob /automations/:automationGroupId/acts, então o repositório precisa do
        // id do grupo no construtor. Mesmo padrão de fábrica usado em events.notes(personId).
        automations: (automationGroupId: string): AutomationsService =>
            new AutomationsService(new AutomationsRepository(automationGroupId)),
        facebook: new FacebookService(new FacebookRepository()),
    }
    brokers = {
        creatives: new CreativesService(new CreativesRepository()),
        recipient: new RecipientsService(new RecipientsRepository()),
        channels: new ChannelsService(new ChannelsRepository()),
        balances: new BrokerBalancesService(new BrokerBalancesRepository()),
    }
    events = {
        // as regras vivem sob /audiences/:audienceId/rules — mesma fábrica por recurso-pai
        audienceRules: (audienceId: string): AudienceRulesService =>
            new AudienceRulesService(new AudienceRulesRepository('audiences/' + audienceId + '/rules')),
        audiences: new AudiencesService(new AudiencesRepository()),
        eventSources: new EventSourcesService(new EventSourcesRepository()),
        events: new EventsService(new EventsRepository()),
        integrations: new IntegrationsService(new IntegrationsRepository()),
        notes: (personId: string): NotesService => new NotesService(new NotesRepository(personId)),
        files: new FilesService(),
        persons: new PersonsService(new PersonsRepository()),
        referrals: new ReferralsService(new ReferralsRepository()),
        settings: new SettingsService(new SettingsRepository()),
        tags: new TagsService(new TagsRepository()),
        comissions: new ComissionsService(new ComissionsRepository()),
        cities: new EventsCitiesService(new EventsCitiesRepository()),
        countries: new CountriesService(new CountriesRepository()),
        geo: new GeoService(new GeoRepository(), new CepGeoRepository()),
    }
    pipelines = {
        boards: new BoardsService(new BoardsRepository()),
        lists: (boardId: string): ListsService => new ListsService(new ListsRepository('boards/' + boardId + '/lists')),
        cards: (boardId: string, listId: string): CardsService => new CardsService(new CardsRepository('boards/' + boardId + '/lists/' + listId + '/cards')),
    }
    pos = {
        balances: new BalancesService(new BalancesRepository()),
        balanceResults: new BalanceResultsService(new BalanceResultsRepository()),
        invoices: new InvoicesService(new InvoicesRepository()),
        paymentMethods: new PaymentMethodsService(new PaymentMethodsRepository()),
        services: new ServicesService(new ServicesRepository()),
        serviceCategories: new ServiceCategoriesService(new ServiceCategoriesRepository()),
        userServiceComissions: new UserServiceComissionsService(new UserServiceComissionsRepository()),
        stock: {
            productInvoices: new ProductInvoicesService(new ProductInvoicesRepository()),
            productMovements: new ProductMovementsService(new ProductMovementsRepository()),
            productConsumption: new ProductConsumptionService(new ProductConsumptionRepository()),
        },
        reports: new PosReportsService(new PosReportsRepository()),
        cashiers: new CashiersService(new CashiersRepository()),
        quotations: new QuotationsService(new QuotationsRepository()),
        taxParams: new TaxParamsService(new TaxParamsRepository()),
        taxInvoices: new TaxInvoicesService(new TaxInvoicesRepository()),
    }
    prospects = {
        business: new BusinessService(new BusinessRepository()),
        categories: new ProspectCategoriesService(new ProspectCategoriesRepository()),
        cities: new CitiesService(new CitiesRepository()),
        //searchItems: new SearchItemsService(new SearchItemsRepository()),
        searchQuery: new SearchQueryService(new SearchQueryRepository()),
        searches: new SearchesService(new SearchesRepository()),
    }
    schedulers = {
        appointments: new AppointmentsService(new AppointmentsRepository()),
        reports: new SchedulerReportsService(new SchedulerReportsRepository()),
        integrations: new SchedulerIntegrationsService(new SchedulerIntegrationsRepository()),
        schedules: new SchedulesService(new SchedulesRepository()),
        scheduleGroups: new ScheduleGroupsService(new ScheduleGroupsRepository()),
        scheduleBlockRules: new ScheduleBlockRulesService(new ScheduleBlockRulesRepository()),
        waitlistEntries: new WaitlistEntriesService(new WaitlistEntriesRepository()),
        agendaNotes: new AgendaNotesService(new AgendaNotesRepository()),
        resourcesLock: new ResourcesLockService(new ResourcesLockRepository()),
        appointmentConsumption: new AppointmentConsumptionService(new AppointmentConsumptionRepository()),
    }
    tools = {
        sharePages: new SharePagesService(new SharePagesRepository()),
        documents: new DocumentsService(new DocumentsRepository()),
        forms: {
            formDatas: new FormDatasService(new FormDatasRepository()),
            formDataLinks: new FormDataLinksService(new FormDataLinksRepository()),
            formTemplates: new FormTemplatesService(new FormTemplatesRepository()),
        },
        formsV2: {
            formTemplates: new FormV2TemplatesService(new FormV2TemplatesRepository()),
            forms: new FormV2FormsService(new FormV2FormsRepository()),
            formLinks: new FormV2FormLinksService(new FormV2FormLinksRepository()),
            formSignatures: new FormV2FormSignaturesService(new FormV2FormSignaturesRepository()),
            formSignatureLogs: new FormV2FormSignatureLogsService(new FormV2FormSignatureLogsRepository()),
        },
        nps: {
            nps: new NPSService(new NPSRepository()),
            reviews: new ReviewsService(new ReviewsRepository()),
        },
        referrals: new ToolsReferralsService(new ToolsReferralsRepository()),
        sites: {
            profiles: new SitesProfilesService(new SitesProfilesRepository()),
            links: new SitesLinksService(new SitesLinksRepository()),
        },
        goalboards: new GoalboardsService(new GoalboardsRepository()),
        partners: {
            partners: new PartnersService(new PartnersRepository()),
            persons: new PartnersPersonsService(new PartnersPersonsRepository()),
            entries: new PartnersEntriesService(new PartnersEntriesRepository()),
        },
        mgmMembers: new MGMembersService(new MGMembersRepository()),
        academy: {
            medialists: new MedialistsService(new MedialistsRepository()),
            medias: new MediasService(new MediasRepository()),
        },
    }
    users = {
        companies: new CompaniesService(new CompaniesRepository()),
        users: new UsersService(new UsersRepository()),
        statistics: new StatisticsService(new StatisticsRepository()),
        managers: new ManagersService(new ManagersRepository()),
        devices: new DevicesService(new DevicesRepository()),
        auth: new AuthService(new AuthRepository()),
        oauth: new OAuthService(new OAuthRepository()),
    }
    payments = {
        charges: new ChargesService(new ChargesRepository()),
        customerCards: new CustomerCardsService(new CustomerCardsRepository()),
        gateways: new GatewaysService(new GatewaysRepository()),
        logs: new LogsService(new LogsRepository()),
        paymentLinks: new PaymentLinksService(new PaymentLinksRepository()),
        purchases: new PurchasesService(new PurchasesRepository()),
    }
    financials = {
        accounts: new AccountsService(new AccountsRepository()),
        categories: new CategoriesService(new CategoriesRepository()),
        entries: new EntriesService(new EntriesRepository()),
        bills: new BillsService(new BillsRepository()),
        recurringBills: new RecurringBillsService(new RecurringBillsRepository()),
        classifications: new ClassificationsService(new ClassificationsRepository()),
        reports: new ReportsService(new ReportsRepository()),
    }
    reports = {
        catalog: new ReportCatalogService(new ReportCatalogRepository()),
    }
    notifications = new NotificationsService(new NotificationsRepository())
    utils = {
        utils: new UtilsBrowserService(),
        internet: new InternetCheckService(),
        dates: new DatesService(),
        images: new ImagesService(),
        conversions: new ConversionsService(),
    }
}
